import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const SET_VALIDATION_ERROR = 'CADASTRAL_FIELDS :: SET_VALIDATION_ERROR';

interface IFieldError {
  key: ECadastralFieldsNames;
  value?: string;
}

export type TSetValidationErrorAction = IReduxAction<typeof SET_VALIDATION_ERROR, IFieldError>;

export const setValidationError = actionGenerator<typeof SET_VALIDATION_ERROR, IFieldError>(SET_VALIDATION_ERROR);
